import ResourceDetail from './ResourceDetail';

export default ResourceDetail;
